<template>
	<vs-row>
		<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" class="text-left">
			 <vs-input class="w-full" :label="$t('MODULE.inputKey')" :placeholder="$t('MODULE.inputKey')" v-model="questionsByPage[index].key"/>
		</vs-col>
		<vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
			<Geo :index="index" :label="$t('MODULE.typeGeo')"></Geo>			
		</vs-col>
		
	</vs-row>
</template>
<script type="text/javascript">
	import Geo from '../../componentsToQuestions/DefaultSelect.vue';
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { Geo },
		computed: {
			...mapState('resource',['questionsByPage']),
		}
	}
	
</script>